// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"993897a4","453":"273bdfae","455":"88ed1cf4","977":"2acc4081"}[chunkId] + ".chunk.js";
};